var _react_refresh_temp_1;
var _react_refresh_temp_2, _react_refresh_temp_3;
_react_refresh_temp_2 = $RefreshSig$();
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useRef, } from 'react';
import { BROADCAST_CHANNEL_NAME } from './BroadcastChannel.constants';
import { BroadcastChannelContext } from './BroadcastChannelContext';
const receiver = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
export const BroadcastChannelProvider = ({ children, }) => {
    _react_refresh_temp_2();
    const eventSubscriptionsMap = useRef(new Map());
    useEffect(() => {
        const listener = (message) => {
            const data = message.data;
            const subscriptions = eventSubscriptionsMap.current.get(data.type) ?? [];
            subscriptions.forEach(({ callback }) => {
                void callback(data);
            });
        };
        receiver.addEventListener('message', listener);
        return () => receiver.removeEventListener('message', listener);
    }, []);
    const subscribeToMessage = useCallback(({ callback, id, messageType }) => {
        if (!eventSubscriptionsMap.current?.has(messageType)) {
            eventSubscriptionsMap.current.set(messageType, []);
        }
        eventSubscriptionsMap.current
            .get(messageType)
            ?.push({ id, callback });
    }, []);
    const unsubscribeFromMessage = useCallback(({ id, messageType }) => {
        const callbackArr = eventSubscriptionsMap.current.get(messageType);
        if (!callbackArr) {
            return;
        }
        const callbackIndex = callbackArr.findIndex((subscription) => subscription.id === id);
        if (callbackIndex === -1) {
            return;
        }
        callbackArr?.splice(callbackIndex, 1);
    }, []);
    const value = useMemo(() => ({
        subscribeToMessage,
        unsubscribeFromMessage,
    }), [subscribeToMessage, unsubscribeFromMessage]);
    return (_jsx(BroadcastChannelContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = BroadcastChannelProvider;
$RefreshReg$(_react_refresh_temp_1, "BroadcastChannelProvider");
_react_refresh_temp_2(BroadcastChannelProvider, "cH46vBqObYBvKJ3PPyStQB6jvlU=");
export const useSubscribeToBroadcastMessage = ({ callback, messageType, }) => {
    _react_refresh_temp_3();
    const broadcastChannelValue = useContext(BroadcastChannelContext);
    const id = useRef(null);
    if (!broadcastChannelValue) {
        throw new Error('BroadcastChannel context not available!');
    }
    useEffect(() => {
        broadcastChannelValue.subscribeToMessage({ messageType, id, callback });
        return () => broadcastChannelValue.unsubscribeFromMessage({ messageType, id });
    }, [broadcastChannelValue, callback, messageType]);
};
_react_refresh_temp_3(useSubscribeToBroadcastMessage, "OFkt5OHvqrpMz/Fvk2zbuQMGATM=");
